import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { AudioDeviceDialog, VideoDeviceDialog } from '../DeviceDialog/DeviceDialog';
import { PSYLARIS_DARK, PSYLARIS_LIGHT_GREY } from '../../../utils/Colors';

const RightUpperCorner = styled('div')({
  position: 'absolute',
  left: '70%',
  top: '15%',
  borderRadius: '50%',
  border: '0.2px solid ' + PSYLARIS_DARK,
  color: PSYLARIS_DARK,
  //width: '20px', -causes the circle not to be round
  //height: '20px', -causes the circle not to be round
  size: 'xs',
  background: PSYLARIS_LIGHT_GREY, //'#ffffff',
  display: 'flex',
  justifyItems: 'center',
  alignItems: 'center',
  zIndex: 10000,
});

interface AVBProps {
  isAudio: boolean;
  t: any;
}

interface AVBState {
  showDialog: boolean;
}

export default class AVDialogButton extends React.Component<AVBProps, AVBState> {
  constructor(props: any) {
    super(props);
    this.state = {
      showDialog: false,
    };
  }

  toggleD(showD: boolean) {
    this.setState({ showDialog: !showD });
  }

  toggleDialog() {
    this.toggleD(this.state.showDialog);
  }

  render() {
    const { t } = this.props;
    const AUDIO_TOOLTIP = t('Select audio');
    const VIDEO_TOOLTIP = t('Select video');

    let TOOLTIP_TITLE;

    const POPUP_AUDIO_DIALOG = (
      <AudioDeviceDialog
        open={this.state.showDialog}
        onClose={() => {
          this.toggleDialog();
        }}
      />
    );
    const POPUP_VIDEO_DIALOG = (
      <VideoDeviceDialog
        open={this.state.showDialog}
        onClose={() => {
          this.toggleDialog();
        }}
      />
    );
    let popupDialog;
    let iconFace = <ExpandLessIcon />;
    if (this.props.isAudio) {
      TOOLTIP_TITLE = AUDIO_TOOLTIP;
      popupDialog = POPUP_AUDIO_DIALOG;
    } else {
      TOOLTIP_TITLE = VIDEO_TOOLTIP;
      popupDialog = POPUP_VIDEO_DIALOG;
    }

    return (
      <div>
        <Tooltip title={TOOLTIP_TITLE} placement="top" PopperProps={{ disablePortal: true }}>
          <RightUpperCorner onClick={this.toggleDialog.bind(this)}>{iconFace}</RightUpperCorner>
        </Tooltip>
        {popupDialog}
      </div>
    );
  }
}
